import { render } from "./addcomment.vue?vue&type=template&id=f9c62f8a"
import script from "./addcomment.vue?vue&type=script&lang=js"
export * from "./addcomment.vue?vue&type=script&lang=js"

import "./addcomment.vue?vue&type=style&index=0&id=f9c62f8a&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__